import { checkCourseAvailability } from '../../../modules/course/api';

export const checkCourseAvailabilityUseCase = async (courseId: number): Promise<boolean> => {
  return checkCourseAvailability(courseId);
};